var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgInfo = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 19,
  height: 20,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#111",
  d: "M9.5 19.188c5.063 0 9.188-4.125 9.188-9.188S14.563.813 9.5.813.312 4.937.312 10s4.125 9.188 9.188 9.188m0-1.414A7.764 7.764 0 0 1 1.726 10 7.764 7.764 0 0 1 9.5 2.226 7.764 7.764 0 0 1 17.274 10 7.764 7.764 0 0 1 9.5 17.774m.707-2.827V7.88H8.793v7.067zm0-8.48V5.052H8.793v1.413z"
})));
export default SvgInfo;